import { renderElement } from "../../utils/use-render.js";
import { usePopoverContext } from "../popover/context.js";
import { PopoverTrigger } from "../popover/trigger.js";
import { useVolumePopoverContext } from "./context.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/volume-popover/trigger.tsx
/** Opens the volume popup, or renders its mute-button fallback when volume level controls are unavailable. */
const VolumePopoverTrigger = forwardRef(function VolumePopoverTrigger({ render, className, style, ...elementProps }, forwardedRef) {
	const { state: popoverState } = usePopoverContext();
	const { state } = useVolumePopoverContext();
	if (!state.hidden) return /* @__PURE__ */ jsx(PopoverTrigger, {
		ref: forwardedRef,
		render,
		className,
		style,
		...elementProps
	});
	return renderElement("button", {
		render,
		className,
		style
	}, {
		state: popoverState,
		ref: forwardedRef,
		props: [{ type: "button" }, elementProps]
	});
});
//#endregion
export { VolumePopoverTrigger };

//# sourceMappingURL=trigger.js.map